import { render, staticRenderFns } from "./MyPayList.vue?vue&type=template&id=5145ebf2&scoped=true&"
import script from "./MyPayList.vue?vue&type=script&lang=js&"
export * from "./MyPayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5145ebf2",
  null
  
)

export default component.exports